import styled from 'styled-components';
import tw, { classnames, scale, borderRadius, boxShadow, padding, backgroundColor, flexWrap, position, fontWeight, textColor, fontSize, gradientColorStops, display, backgroundSize } from 'tailwindcss-classnames';

const commonClasses = classnames(scale('hover:scale-100' as any), borderRadius('rounded-b-2xl'), boxShadow('shadow-xl', 'hover:shadow-2xl'), padding('px-0', 'pb-4'), backgroundColor('bg-gray-100'), flexWrap('flex-wrap'), position('relative'));

// className: commonClasses + classnames(boxShadow('shadow-lg'))
export const HorizontalContainer = (size: 'sm'|'md'|'lg') => {
    const height = size === 'md' ? '60px' :
        size === 'lg' ? '100px' :
        size === 'sm' ? '80px' : '40px';
    return styled.div.attrs({
    className: classnames(commonClasses)
})`
    min-height: ${height};
`};
export const SquareContainer = styled.div.attrs({})``;

export const Title = (size: 'sm'|'md'|'lg') => styled.h3.attrs({
    className: classnames(scale('focus:scale-150' as any), 'hover:text-gpas-100' as any, padding('pt-2', 'pb-2'), fontWeight('font-bold'), textColor('text-white'))
})`
    font-size: ${size === 'lg' ? '2rem' : size === 'md' ? '1.6rem' : '1.2rem'};
`;

export const Subtitle = styled.span.attrs({
    className: classnames(padding('pt-1'), fontSize('text-xs'), textColor('text-white'), gradientColorStops('from-gray-900'))
})`
`;
// font-weight: 400;

export const PreviewImage = (imageURL: string, size: 'sm'|'md'|'lg') => {
    const height = size === 'md' ? '230px' :
        size === 'lg' ? '330px' :
        size === 'sm' ? '130px' : '100px';

    return styled.div.attrs({
        className: classnames(scale('hover:scale-100' as any), display('flex'), borderRadius('rounded-sm'), position('relative'), backgroundSize('bg-cover'))
    })`
        background: linear-gradient(rgba(0,0,0,0.2), rgba(0, 0, 0, 0.9) ), url('${imageURL}') no-repeat ;
        background-size:     cover;
        background-repeat:   no-repeat;
        min-height: ${height};
        background-position: center center;
`;
};

export const HeaderContainer = styled.div.attrs({
    className: classnames(padding('py-4', 'px-6'), backgroundColor('bg-transparent'), borderRadius('rounded-tr-sm'), position('absolute'))
})`
    bottom: 0;
`;

export const Content = styled.div.attrs({
    className: classnames(padding('px-4', 'py-2'))
})``
